import { useState } from "react";

import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

export default function ConfirmationDialog({
    open,
    closeDialog,
    title,
    children,
    callback,
    hideOk,
}) {
    const [loading, setLoading] = useState(false);

    const stopPropagation = (event) => {
        event.stopPropagation();
    };

    const handleCancel = (event) => {
        event.stopPropagation();
        closeDialog();
    };

    const handleOk = (event) => {
        event.stopPropagation();
        setLoading(true);
        callback();
        closeDialog();
        setLoading(false);
    };

    return (
        <Dialog open={open} onClose={handleCancel}>
            <DialogTitle onClick={stopPropagation}>{title}</DialogTitle>
            <DialogContent dividers onClick={stopPropagation}>
                {children}
            </DialogContent>
            <DialogActions onClick={stopPropagation}>
                {loading ? (
                    <CircularProgress size={30} sx={{ marginRight: "12px" }} />
                ) : null}

                <Button onClick={handleCancel} color="secondary">
                    Cancel
                </Button>

                {hideOk ? null : (
                    <Button onClick={handleOk} color="primary">
                        Continue
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
}
